// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Pk-z","breadcrumbItem":"Qk-z"};